import React, { useState, useEffect } from "react";
import "./App.css";
import Background from "./background";
import CustomCursor from "./utils/cursor";
import ScrollToTop from "./utils/ScrollToTop";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransition from "./utils/Transitions/PageTransition";
import PageWrapper from "./utils/Transitions/PageWrapper";
import Navigation from "./components/Header/nav";
import HomePage from "./components/Header/HomePage";
import Rhys from "./projects/rhys";
import XMLTools from "./projects/XMLtools";
import Video from "./projects/JamaisVu";
import Resume from "./components/Resume/ResumeComponent";
import About from "./components/About/AboutComponent";
import Transcendence from "./projects/Transcendence";
import SocialNest from "./projects/Socialnest";
import Macker from "./projects/Macker";
import Automail from "./projects/Automail";
import Design from './components/Layout/Design';
import Develop from './components/Layout/Develop';
import Engage from './components/Layout/Engage';
import Play from './components/Layout/Play';
import ProjectAnimationTest from './components/Experiments/ProjectAnimationTest';
import Arcteryx from './components/Projects/Engage/Arcteryx';
import Redbull from './components/Projects/Engage/Redbull';
import CSSC from './components/Projects/Engage/CSSC';
import Preloader from './components/Preloader/Preloader';

// Import the Providers
import { FilterProvider } from "./utils/FilterContext";
import { MouseProvider } from "./utils/MouseContext";
import { colors } from './utils/theme';

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: #000;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }
  /* ... existing styles ... */
`;

// Wrap component with PageWrapper
const wrapComponent = (Component) => (props) => (
  <PageWrapper>
    <Component {...props} />
  </PageWrapper>
);

function App() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <div className="App">
      <MouseProvider>
        <FilterProvider>
          {isLoading ? (
            <Preloader minLoadingTime={2000} onLoadingComplete={handleLoadingComplete} />
          ) : (
            <>
              <ScrollToTop />
              <Background />
              <CustomCursor />
              <Navigation />
              <AnimatePresence mode="wait" initial={false}>
                <Routes location={location} key={location.pathname}>
                  <Route path="/" element={wrapComponent(HomePage)()} />
                  <Route path="/rhys-bot" element={wrapComponent(Rhys)()} />
                  <Route path="/xml-tools" element={wrapComponent(XMLTools)()} />
                  <Route path="/JamaisVu" element={wrapComponent(Video)()} />
                  <Route path="/resume" element={wrapComponent(Resume)()} />
                  <Route path="/About" element={wrapComponent(About)()} />
                  <Route path="/transcendence" element={wrapComponent(Transcendence)()} />
                  <Route path="/SocialNest" element={wrapComponent(SocialNest)()} />
                  <Route path="/Macker" element={wrapComponent(Macker)()} />
                  <Route path="/Automail" element={wrapComponent(Automail)()} />
                  <Route path="/design" element={wrapComponent(Design)()} />
                  <Route path="/develop" element={wrapComponent(Develop)()} />
                  <Route path="/engage" element={wrapComponent(Engage)()} />
                  <Route path="/play" element={wrapComponent(Play)()} />
                  <Route path="/animation-test" element={wrapComponent(ProjectAnimationTest)()} />
                  <Route path="/projects/arcteryx" element={wrapComponent(Arcteryx)()} />
                  <Route path="/projects/redbull" element={wrapComponent(Redbull)()} />
                  <Route path="/projects/cssc" element={wrapComponent(CSSC)()} />
                </Routes>
                <PageTransition key="transition" />
              </AnimatePresence>
              <GlobalStyle />
            </>
          )}
        </FilterProvider>
      </MouseProvider>
    </div>
  );
}

export default App;
